import { Link } from "react-router-dom";
import type { NewsPost } from "../../content/types";
import { formatPostDate, unpublishedLabel } from "../../news/posts";

interface NewsCardProps {
  post: NewsPost;
  /** Position in the grid, used to stagger the scroll reveal */
  revealOrder?: number;
  /** h2 on the news page; h3 where the cards sit under a section heading */
  headingLevel?: 2 | 3;
}

export default function NewsCard({ post, revealOrder = 0, headingLevel = 2 }: NewsCardProps) {
  const draft = unpublishedLabel(post);
  const Heading = headingLevel === 3 ? "h3" : "h2";

  return (
    <article className="km-card nw-card" data-reveal style={{ "--reveal-order": revealOrder } as React.CSSProperties}>
      {post.imageUrl && (
        <img className="nw-card-image" src={post.imageUrl} alt={post.imageAlt ?? ""} loading="lazy" />
      )}
      <div className="nw-card-body">
        <p className="nw-meta">
          {draft && <span className="nw-chip nw-chip--draft">{draft}</span>}
          {post.category && <span className="nw-chip">{post.category}</span>}
          <time dateTime={post.publishedOn}>{formatPostDate(post.publishedOn)}</time>
        </p>
        <Heading className="nw-card-title">
          {/* The link covers the whole card (see .nw-card-title a::after) */}
          <Link to={`/news/${post.slug}`}>{post.title}</Link>
        </Heading>
        <p className="nw-card-summary">{post.summary}</p>
        <span className="nw-card-more" aria-hidden="true">Read article <span className="km-arrow">→</span></span>
      </div>
    </article>
  );
}
